/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationQueryKey,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface AttachmentsService {
  /**
   * @summary Get Attachment
   * @description Get attachment metadata with URL.
   */
  getAttachment: {
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetAttachmentSchema, GetAttachmentParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetAttachmentParameters, TMeta, TSignal>,
      client?: (
        schema: GetAttachmentSchema,
        options: {
          parameters: GetAttachmentParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAttachmentData, GetAttachmentError>>
    ): Promise<RequestFnResponse<GetAttachmentData, GetAttachmentError>>;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    getQueryKey(
      parameters: DeepReadonly<GetAttachmentParameters>
    ): ServiceOperationQueryKey<GetAttachmentSchema, GetAttachmentParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.attachmentsService.getAttachment.useQuery({
     *     path: {
     *         attachment_id: attachmentId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAttachmentData>(
      parameters:
        | ServiceOperationQueryKey<GetAttachmentSchema, GetAttachmentParameters>
        | DeepReadonly<GetAttachmentParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAttachmentData,
          GetAttachmentError,
          TData,
          ServiceOperationQueryKey<GetAttachmentSchema, GetAttachmentParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAttachmentError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.attachmentsService.getAttachment.useQuery({
     *     path: {
     *         attachment_id: attachmentId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAttachmentData>(
      parameters:
        | ServiceOperationQueryKey<GetAttachmentSchema, GetAttachmentParameters>
        | DeepReadonly<GetAttachmentParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetAttachmentData,
          GetAttachmentError,
          TData,
          ServiceOperationQueryKey<GetAttachmentSchema, GetAttachmentParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAttachmentError>>;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAttachmentParameters>
    ): ServiceOperationInfiniteQueryKey<GetAttachmentSchema, GetAttachmentParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.attachmentsService.getAttachment.useInfiniteQuery({
     *     path: {
     *         attachment_id: attachmentId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAttachmentParameters,
      TQueryFnData = GetAttachmentData,
      TData = OperationInfiniteData<TQueryFnData, GetAttachmentParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAttachmentSchema, GetAttachmentParameters>
        | DeepReadonly<GetAttachmentParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAttachmentError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAttachmentSchema, GetAttachmentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAttachmentError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.attachmentsService.getAttachment.useInfiniteQuery({
     *     path: {
     *         attachment_id: attachmentId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAttachmentParameters,
      TQueryFnData = GetAttachmentData,
      TData = OperationInfiniteData<TQueryFnData, GetAttachmentParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAttachmentSchema, GetAttachmentParameters>
        | DeepReadonly<GetAttachmentParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAttachmentError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAttachmentSchema, GetAttachmentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAttachmentData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAttachmentError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAttachmentTotal = qraft.attachmentsService.getAttachment.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getAttachmentByParametersTotal = qraft.attachmentsService.getAttachment.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             attachment_id: attachmentId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAttachmentSchema,
            GetAttachmentData,
            TInfinite,
            GetAttachmentParameters,
            GetAttachmentError
          >
        | QueryFiltersByQueryKey<
            GetAttachmentSchema,
            GetAttachmentData,
            TInfinite,
            GetAttachmentParameters,
            GetAttachmentError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAttachmentResults = qraft.attachmentsService.getAttachment.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 attachment_id: attachmentId1
     *             }
     *         },
     *         {
     *             path: {
     *                 attachment_id: attachmentId2
     *             }
     *         }
     *     ]
     * });
     * getAttachmentResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAttachmentCombinedResults = qraft.attachmentsService.getAttachment.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 attachment_id: attachmentId1
     *             }
     *         },
     *         {
     *             path: {
     *                 attachment_id: attachmentId2
     *             }
     *         }
     *     ]
     * });
     * getAttachmentCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAttachmentSchema,
          GetAttachmentParameters,
          GetAttachmentData,
          GetAttachmentError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAttachmentData, GetAttachmentError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetAttachmentData, GetAttachmentError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.attachmentsService.getAttachment.useSuspenseQuery({
     *     path: {
     *         attachment_id: attachmentId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetAttachmentData>(
      parameters:
        | ServiceOperationQueryKey<GetAttachmentSchema, GetAttachmentParameters>
        | DeepReadonly<GetAttachmentParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAttachmentData,
          GetAttachmentError,
          TData,
          ServiceOperationQueryKey<GetAttachmentSchema, GetAttachmentParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAttachmentError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.attachmentsService.getAttachment.useSuspenseInfiniteQuery({
     *     path: {
     *         attachment_id: attachmentId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetAttachmentParameters, TData = GetAttachmentData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAttachmentSchema, GetAttachmentParameters>
        | DeepReadonly<GetAttachmentParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAttachmentData,
          GetAttachmentError,
          OperationInfiniteData<TData, GetAttachmentParameters>,
          ServiceOperationInfiniteQueryKey<GetAttachmentSchema, GetAttachmentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAttachmentData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAttachmentParameters>,
      OperationError<GetAttachmentError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAttachmentData = qraft.attachmentsService.getAttachment.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 attachment_id: attachmentId1
     *             }
     *         },
     *         {
     *             path: {
     *                 attachment_id: attachmentId2
     *             }
     *         }
     *     ]
     * });
     * getAttachmentResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAttachmentCombinedData = qraft.attachmentsService.getAttachment.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 attachment_id: attachmentId1
     *             }
     *         },
     *         {
     *             path: {
     *                 attachment_id: attachmentId2
     *             }
     *         }
     *     ]
     * });
     * getAttachmentCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAttachmentSchema,
          GetAttachmentParameters,
          GetAttachmentData,
          GetAttachmentError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetAttachmentData, GetAttachmentError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetAttachmentData, GetAttachmentError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAttachmentSchema,
        GetAttachmentData,
        GetAttachmentParameters,
        GetAttachmentError
      >
    ): Promise<GetAttachmentData>;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAttachmentSchema,
        GetAttachmentData,
        GetAttachmentParameters,
        GetAttachmentError
      >
    ): Promise<void>;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAttachmentSchema,
        GetAttachmentData,
        GetAttachmentParameters,
        GetAttachmentError
      >
    ): Promise<GetAttachmentData>;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    fetchInfiniteQuery<TPageParam extends GetAttachmentParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAttachmentSchema,
        GetAttachmentData,
        GetAttachmentParameters,
        DeepReadonly<TPageParam>,
        GetAttachmentError
      >
    ): Promise<OperationInfiniteData<GetAttachmentData, GetAttachmentParameters>>;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    prefetchInfiniteQuery<TPageParam extends GetAttachmentParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAttachmentSchema,
        GetAttachmentData,
        GetAttachmentParameters,
        DeepReadonly<TPageParam>,
        GetAttachmentError
      >
    ): Promise<void>;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    ensureInfiniteQueryData<TPageParam extends GetAttachmentParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAttachmentSchema,
        GetAttachmentData,
        GetAttachmentParameters,
        DeepReadonly<TPageParam>,
        GetAttachmentError
      >
    ): Promise<OperationInfiniteData<GetAttachmentData, GetAttachmentParameters>>;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAttachmentSchema, GetAttachmentParameters>
        | DeepReadonly<GetAttachmentParameters>
    ): GetAttachmentData | undefined;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAttachmentSchema, GetAttachmentParameters>
        | DeepReadonly<GetAttachmentParameters>
    ): OperationInfiniteData<GetAttachmentData, GetAttachmentParameters> | undefined;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAttachmentSchema,
            GetAttachmentData,
            TInfinite,
            GetAttachmentParameters,
            GetAttachmentError
          >
        | QueryFiltersByQueryKey<
            GetAttachmentSchema,
            GetAttachmentData,
            TInfinite,
            GetAttachmentParameters,
            GetAttachmentError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetAttachmentSchema, GetAttachmentParameters>,
            data: NoInfer<OperationInfiniteData<GetAttachmentData, GetAttachmentParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetAttachmentSchema, GetAttachmentParameters>,
            data: GetAttachmentData | undefined,
          ]
        >;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAttachmentSchema, GetAttachmentParameters>
        | DeepReadonly<GetAttachmentParameters>
    ): QueryState<GetAttachmentData, GetAttachmentError> | undefined;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAttachmentParameters>
        | ServiceOperationInfiniteQueryKey<GetAttachmentSchema, GetAttachmentParameters>
    ): QueryState<OperationInfiniteData<GetAttachmentData, GetAttachmentParameters>, GetAttachmentError> | undefined;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetAttachmentParameters>
        | ServiceOperationQueryKey<GetAttachmentSchema, GetAttachmentParameters>,
      updater: Updater<NoInfer<GetAttachmentData> | undefined, NoInfer<DeepReadonly<GetAttachmentData>> | undefined>,
      options?: SetDataOptions
    ): GetAttachmentData | undefined;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetAttachmentParameters>
        | ServiceOperationInfiniteQueryKey<GetAttachmentSchema, GetAttachmentParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetAttachmentData, GetAttachmentParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetAttachmentData, GetAttachmentParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAttachmentData, GetAttachmentParameters> | undefined;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAttachmentSchema,
            GetAttachmentData,
            TInfinite,
            GetAttachmentParameters,
            GetAttachmentError
          >
        | QueryFiltersByQueryKey<
            GetAttachmentSchema,
            GetAttachmentData,
            TInfinite,
            GetAttachmentParameters,
            GetAttachmentError
          >,
      updater: Updater<NoInfer<GetAttachmentData> | undefined, NoInfer<GetAttachmentData> | undefined>,
      options?: SetDataOptions
    ): Array<GetAttachmentData | undefined>;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAttachmentSchema,
        GetAttachmentData,
        TInfinite,
        GetAttachmentParameters,
        GetAttachmentError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAttachmentSchema,
            GetAttachmentData,
            TInfinite,
            GetAttachmentParameters,
            GetAttachmentError
          >
        | QueryFiltersByQueryKey<
            GetAttachmentSchema,
            GetAttachmentData,
            TInfinite,
            GetAttachmentParameters,
            GetAttachmentError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAttachmentSchema,
            GetAttachmentData,
            TInfinite,
            GetAttachmentParameters,
            GetAttachmentError
          >
        | QueryFiltersByQueryKey<
            GetAttachmentSchema,
            GetAttachmentData,
            TInfinite,
            GetAttachmentParameters,
            GetAttachmentError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAttachmentSchema,
            GetAttachmentData,
            TInfinite,
            GetAttachmentParameters,
            GetAttachmentError
          >
        | QueryFiltersByQueryKey<
            GetAttachmentSchema,
            GetAttachmentData,
            TInfinite,
            GetAttachmentParameters,
            GetAttachmentError
          >
    ): void;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAttachmentSchema,
            GetAttachmentData,
            TInfinite,
            GetAttachmentParameters,
            GetAttachmentError
          >
        | QueryFiltersByQueryKey<
            GetAttachmentSchema,
            GetAttachmentData,
            TInfinite,
            GetAttachmentParameters,
            GetAttachmentError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Attachment
     * @description Get attachment metadata with URL.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAttachmentSchema,
            GetAttachmentData,
            TInfinite,
            GetAttachmentParameters,
            GetAttachmentError
          >
        | QueryFiltersByQueryKey<
            GetAttachmentSchema,
            GetAttachmentData,
            TInfinite,
            GetAttachmentParameters,
            GetAttachmentError
          >
    ): number;
    schema: GetAttachmentSchema;
    types: {
      parameters: GetAttachmentParameters;
      data: GetAttachmentData;
      error: GetAttachmentError;
    };
  };
}
/**
 * @summary Get Attachment
 * @description Get attachment metadata with URL.
 */
export const getAttachment = {
  schema: {
    method: 'get',
    url: '/attachments/{attachment_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAttachmentSchema;
  [QraftServiceOperationsToken]: AttachmentsService['getAttachment'];
};
export const attachmentsService = {
  getAttachment,
} as const;
type GetAttachmentSchema = {
  method: 'get';
  url: '/attachments/{attachment_id}';
  security: ['HTTPBearer'];
};
type GetAttachmentParameters = paths['/attachments/{attachment_id}']['get']['parameters'];
type GetAttachmentData =
  paths['/attachments/{attachment_id}']['get']['responses']['200']['content']['application/json'];
type GetAttachmentError =
  paths['/attachments/{attachment_id}']['get']['responses']['422']['content']['application/json'];
